const BooleanEditor = () => {
	// eslint-disable-next-line react/destructuring-assignment
	// if (props.label === 'Ponavljanje') {
    return null;
};

export default BooleanEditor;
